import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get relatorio de atendimentos data by team.
*/
export const getAttendancesReportData = async (count?: number, teamId?: string): Promise<any> => {
    teamId = teamId ? `&teamId=${teamId}` : ``;
    const url = `${baseAxiosUrl}/api/teampanel/getattendancesreportdata?daysCount=${count}${teamId}`;
    return await axios.get(url);
}

/**
* Get visão geral atendimentos data by team.
*/
export const getGeneralViewUnidadeData = async (teamId: string, count: number): Promise<any> => {
    const url = `${baseAxiosUrl}/api/teampanel/getgeneralviewunidadedata?teamId=${teamId}&daysCount=${count}`;
    return await axios.get(url);
}

/**
* Get queues status count by team
*/
export const getQueuesStatusCountByTeam = async (teamId: string, date?: Date | null, atendenteId?: string | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    const url = `${baseAxiosUrl}/api/teampanel/getqueuesstatuscountbyteam?teamId=${teamId}${dateTime}${atendente}${filters}`;
    return await axios.get(url);
}

/**
* Get all meeting queues by id for team.
*/
export const getAllQueuesDataByTeam = async (teamId: string, offset: number, limit: number, date?: Date | null, atendenteId?: string | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    const url = `${baseAxiosUrl}/api/teampanel/getallqueuesbyteam?teamId=${teamId}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}`;
    return await axios.get(url, undefined, false);
}

/**
* Get started queues for team.
*/
export const getStartedQueuesByTeam = async (teamId: string, offset: number, limit: number, date?: Date | null, atendenteId?: string | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    const url = `${baseAxiosUrl}/api/teampanel/getstartedqueuesbyteam?teamId=${teamId}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}`;
    return await axios.get(url);
}

/**
* Get ended queues for team.
*/
export const getEndedQueuesByTeam = async (teamId: string, offset: number, limit: number, date?: Date | null, atendenteId?: string | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let atendente = atendenteId ? `&atendenteId=${atendenteId}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    const url = `${baseAxiosUrl}/api/teampanel/getendedqueuesbyteam?teamId=${teamId}&offset=${offset}&limit=${limit}${dateTime}${atendente}${filters}`;
    return await axios.get(url);
}

/**
* Get expired queues for team.
*/
export const getExpiredQueuesByTeam = async (teamId: string, offset: number, limit: number, date?: Date | null, filter?: string | null): Promise<any> => {
    let dateTime = date ? `&date=${date}` : ``;
    let filters = filter ? `&filter=${filter}` : ``;

    const url = `${baseAxiosUrl}/api/teampanel/getexpiredqueuesbyteam?teamId=${teamId}&offset=${offset}&limit=${limit}${dateTime}${filters}`;
    return await axios.get(url);
}

/**
* Terminate queue call (atendimento).
*/
export const endCall = async (id: string, justification: string): Promise<any> => {
    const payload = {
        notes: justification,
    }

    const url = `${baseAxiosUrl}/api/serventias/endcall?id=${id}`;
    return await axios.put(url, payload);
}